import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  SxProps,
  Typography,
} from '@mui/material';
import { Theme } from '@mui/system';
import { X } from 'phosphor-react';
import React from 'react';

export type ModalProps = {
  open: boolean;
  icon?: JSX.Element;
  title?: string;
  titleProps?: SxProps<Theme>;
  description?: string;
  modalWidth?: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  handleClose: () => void;
};

export const ModalKit = ({
  open,
  icon,
  title,
  titleProps,
  description,
  modalWidth = '500px',
  children,
  footer,
  handleClose,
}: ModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='responsive-dialog-title'
      sx={{
        backdropFilter: 'blur(4px)',
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: modalWidth,
          borderRadius: '4px',
        },
      }}
      PaperProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: '36px',
          boxShadow: 'none',
          padding: '24px',
          boxSizing: 'border-box',
        },
      }}
    >
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: '10px',
          top: '10px',
          color: theme => theme.palette.grey[500],
        }}
      >
        <X width={15} height={15} />
      </IconButton>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        {icon}
        {!!title && (
          <DialogTitle
            sx={{
              textAlign: 'center',
              fontWeight: '600',
              fontSize: '20px',
              color: '#202A2D',
              lineHeight: '17px',
              padding: 0,
              ...titleProps,
            }}
            id='responsive-dialog-title'
          >
            {title}
          </DialogTitle>
        )}
        {!!description && (
          <Typography sx={{ color: '#475467', fontSize: '14px' }}>
            {description}
          </Typography>
        )}
      </Box>

      {!!children && (
        <DialogContent sx={{ padding: 0, overflow: 'hidden' }}>
          {children}
        </DialogContent>
      )}
      {footer && footer}
    </Dialog>
  );
};
